module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/apple-icon-180x180-10000b5fe71c3d062a6233dccdd2fce7.png";